/* clean-cutouts.js — swap studio product photos for transparent cutouts (pp.cutouts) so the product sits on
   pure white with a drop shadow that follows its outline. Map: window.CLEAN_CUTOUTS (filename -> asset url).
   2026-10-04: runs INLINE in <head> (snippet) so images are swapped as the parser inserts them, before they paint; the
   photo stays invisible until the cutout has loaded and only then gets the cutout padding/shadow — otherwise the old
   rectangular photo was shown with the outline drop-shadow ("weird image outline" while loading on slow networks). */
(function () {
  'use strict';
  var MAP = window.CLEAN_CUTOUTS || {};
  var SEL = '.product__media img, .card__media img, .clean-card__media img, .clean-hero__tile img, .clean-details__media img, .thumbnail img, .fish-tier__img img, .fish-pill--thumb img, .fish-sticky-bar__thumb, .cart-item__media img, .cart-item__image, .cart-notification-product__image img, .predictive-search__image';
  var FRAME = '.product__media, .card__media .media, .clean-card__media, .clean-hero__tile, .clean-details__media, .thumbnail, .fish-tier__img, .fish-pill--thumb, .cart-item__media, .cart-item__link';
  function base(src) { try { return decodeURIComponent(new URL(src, location.href).pathname.split('/').pop()); } catch (e) { return ''; } }
  function swap(img) {
    if (img.dataset.cut) return;
    var url = MAP[base(img.getAttribute('src') || img.currentSrc || '')];
    img.dataset.cut = url ? '1' : '0';
    if (!url) return;
    var frame = img.closest(FRAME);
    if (frame) frame.classList.add('is-cutout');
    img.style.opacity = '0';
    img.addEventListener('load', function () {
      img.classList.add('is-cutout-img');
      img.style.transition = 'opacity .15s ease'; img.style.opacity = '';
    }, { once: true });
    img.addEventListener('error', function () { img.style.opacity = ''; }, { once: true });
    img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = url;
  }
  function visit(n) {
    if (n.nodeType !== 1) return;
    if (n.tagName === 'IMG') { if (n.matches(SEL)) swap(n); return; }
    if (n.querySelectorAll) n.querySelectorAll('img').forEach(function (i) { if (i.matches(SEL)) swap(i); });
  }
  function scan() { document.querySelectorAll(SEL).forEach(swap); }
  new MutationObserver(function (ms) { ms.forEach(function (m) { m.addedNodes.forEach(visit); }); })
    .observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== 'loading') scan(); else document.addEventListener('DOMContentLoaded', scan);
})();
